// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ScanProductionStepInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/scan_production_step
 *
 * QR code double-scan for production step tracking.
 */
import { registerContract } from './validate'

export interface Orders_ScanProductionStepInput {
station_qrcode: string
item_qrcode: string
force?: boolean
}

registerContract('Orders_ScanProductionStepInput', {
  station_qrcode: { type: 'string',  required: true },
  item_qrcode:    { type: 'string',  required: true },
  force:          { type: 'boolean', required: false },
})
